"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INSTRUCTIONS_LENGTH = exports.INSTRUCTIONS = void 0;
const INSTRUCTIONS = {
  CREATE: 1n,
  UPDATE: 2n,
  DELETE: 4n,
  TEMPORARY: 8n
};
exports.INSTRUCTIONS = INSTRUCTIONS;
const INSTRUCTIONS_LENGTH = BigInt(Object.keys(INSTRUCTIONS).length);
exports.INSTRUCTIONS_LENGTH = INSTRUCTIONS_LENGTH;